import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts";
import Breadcrumb from "../components/UI/breadcrumb";

const About = () => {
    return (
        <Fragment>
            <MetaTags>
                <title>Adaptive Systems LLC | TCPA Consent</title>
                <meta
                    name="description"
                    content=""
                />
            </MetaTags>
            <LayoutOne>
                <Breadcrumb title="TCPA Consent" />
                <div className="container pt--60 pb--60">
                    <h4>Effective Date: 07 July 2025</h4>

                    <p>By submitting your information on Adaptive Systems LLC’ website, you agree to the following:</p>

                    <ul>
                        <li>You consent to be contacted by Adaptive Systems LLC and its partners by phone, text message, or email at the contact information you provide, including through the use of automated technology.</li>
                        <li>Your consent is not required as a condition of purchase.</li>
                        <li>Standard message and data rates may apply.</li>
                    </ul>

                    <h4>Form Consent Language (placed under the lead form):</h4>

                    <ul>
                        <li>“By checking this box, I consent to receive calls, emails, and text messages from Adaptive Systems LLC and its partners at the number I provided, including via automated technology, about internet and TV services. I understand that my consent is not required to make a purchase.”</li>
                    </ul>

                    <p>If you wish to withdraw your consent, email us at info@adaptivesystems-llc.com</p>
                   
                </div>
            </LayoutOne>
        </Fragment>
    );
};

export default About;
